export default {
    getCurrentStep(state) {
        return state.gameOptions.currentStep;
    },
    getSavedOptions(state) {
        return state.gameOptions.savedOptions;
    },
    getIsUpadtingOption(state) {
        return state.gameOptions.isUpdatingOption;
    },
    getHouseholdMembers(state) {
        const members = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Broj ukućana'));

        if (members >= 0) {
            return state.gameOptions.savedOptions[members].data.value;
        } else {
            return 0;
        }
    },
    getInitalBudgetAmout(state) {
        const initalBudget = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Budžet'));

        return state.gameOptions.savedOptions[initalBudget].data.value;
    },
    getBudgetAmount(state, getters) {
        const initalBudget = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Budžet'));
        const phases = state.buildingPhases.savedMaterials;

        if (initalBudget >= 0) {
            let budget = state.gameOptions.savedOptions[initalBudget].data.value;
            if (phases.length) {
                phases.forEach(phase => {
                    if (phase.data.length) {
                        phase.data.forEach(material => {
                            if (phase.key.toLowerCase().includes('stolarija')) {
                                budget = budget - (parseInt(material.price.value) * getters.getWindowQuantity);
                            } else if (phase.key.toLowerCase().includes('okućnica')) {
                                budget = budget - (parseInt(material.price.value) * getters.getGardenSurfaceArea);
                            } else if (material.name.toLowerCase().includes('kosi krov')) {
                                budget = budget - (parseInt(material.price.value) * getters.getHipRoofSurfaceArea);
                            } else if (material.price.unit.abbreviation == null) {
                                budget = budget - parseInt(material.price.value);
                            } else {
                                budget = budget - (material.price.value * getters.getSurfaceArea);
                            }
                        });
                    }
                });
            }
            return budget;
        } else {
            return 0;
        }
    },
    getBudgetCurrency(state) {
        const budget = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Budžet'));

        if (budget >= 0) {
            return state.gameOptions.savedOptions[budget].data.unit.abbreviation;
        } else {
            return 'EUR';
        }
    },
    getBudgetFormatted(_, getters) {
        return `${Number(getters.getBudgetAmount).toLocaleString('hr')} ${getters.getBudgetCurrency}`;
    },
    getSurfaceArea(state) {
        const surfaceArea = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Površina'));

        if (surfaceArea >= 0) {
            return state.gameOptions.savedOptions[surfaceArea].data.value;
        } else {
            return 0;
        }
    },
    getGardenSurfaceArea(state) {
        const garden = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Površina'));

        if (garden >= 0) {
            return state.gameOptions.savedOptions[garden].data.garden;
        } else {
            return state.gameOptions.savedOptions[garden].data.value;
        }
    },
    getHipRoofSurfaceArea(state) {
        const hipRoof = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Površina'));

        if (hipRoof >= 0) {
            return state.gameOptions.savedOptions[hipRoof].data.hipRoof;
        } else {
            return state.gameOptions.savedOptions[hipRoof].data.value;
        }
    },
    getWindowQuantity(state) {
        const windowQuantity = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Površina'));

        if (windowQuantity >= 0) {
            return state.gameOptions.savedOptions[windowQuantity].data.windowQuantity;
        } else {
            return 10;
        }
    },
    getLocation(state) {
        const location = state.gameOptions.savedOptions.findIndex(option => option.key.includes('Lokacija'));

        if (location >= 0) {
            return state.gameOptions.savedOptions[location].data.uniqueId;
        } else {
            return 0;
        }
    },
    getCurrentPhase(state) {
        return state.buildingPhases.currentPhase;
    },
    getSavedMaterials(state) {
        return state.buildingPhases.savedMaterials;
    },
    getSavedMaterialsIds(state) {
        let ids = [];

        state.buildingPhases.savedMaterials.forEach(material => {
            if (material.data.length) {
                material.data.forEach(mat => {
                    ids.push(mat.uniqueId);
                })
            }
        })

        return ids;
    },
    getVectaryModel(state) {
        return state.model;
    },
    getVectaryModelScreenshot(state) {
        return state.modelScreenshot;
    },
    getTooltipsTotalCount(state) {
        return state.tooltips.totalCount;
    },
    getTooltipsActive(state) {
        return state.tooltips.active;
    },
    getTooltipsSeenAll(state) {
        return state.tooltips.seenAll;
    },
    getTooltipsLearnMore(state) {
        return state.tooltips.learnMoreActive;
    },
    getTooltipsOverview(state) {
        return state.tooltips.overviewTooltips;
    },
    getSavedResult(state) {
        return state.result;
    }
};
